import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionsContext';

export default function ProtectedRoute({ children, requiredPermission }) {
  const { user, loading: authLoading } = useAuth();
  const { hasPermission, loading: permLoading } = usePermissions();

  if (authLoading || permLoading) return <div>Chargement...</div>;

  if (!user) return <Navigate to="/login" replace />;

  if (requiredPermission && !hasPermission(user.role, requiredPermission)) {
    return <div>Accès refusé - Vous n'avez pas la permission requise.</div>;
  }

  return children;
}